import React, { useEffect, useState } from 'react'
import {   Space, Table, Flex    } from 'antd';
import Main from '../../../cpn/Main';
import ShopEdit from './ShopEdit';
import ShopAdd from './ShopAdd';
import { usePingtaiTypeListQuery } from '../../../store/DianShangYeWuApi';
import ShopDel from './ShopDel';  

function ShopList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = usePingtaiTypeListQuery({dspt_qy_id:qy_id,});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {dspt_id:key,dspt_name,dspt_uname,dspt_ctime} = item;                 
                    return item = {key,dspt_name,dspt_uname,dspt_ctime}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'dspt_name',
            title: '名称',            
            dataIndex: 'dspt_name',
        },              
        {
            key: 'dspt_ctime',
            title: '新增',            
            dataIndex: 'dspt_ctime',
            render:(text,record) => {
                return<>{text} {record.dspt_uname}</>
            }
        },   
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space align='center' size='middle'>
                        <ShopEdit
                            dspt_id={record.key} 
                            dspt_name={record.dspt_name} 
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                        />
                        <ShopDel
                            dspt_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/ShopList']}>            
            <Flex>
                <ShopAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `${total}条`,
                }} 
                className="custom-table"
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default ShopList
